<template>
  <div class="content">
    <!-- 头部部分 -->
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="dateKey">
        <el-select v-model="queryParams.dateKey" filterable placeholder="选择时间筛选方式" @change="selectSearch()" clearable>
          <el-option v-for="item in timeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="currency">
        <el-select v-model="queryParams.currency" filterable placeholder="币种" @change="search" clearable>
          <el-option v-for="item in currencyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="dateRange" v-if="searchTimeShow">
          <el-date-picker
            :picker-options="pickerOptions"
            
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="searchTime"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item  prop="month" v-if="monthShow">
          <el-date-picker
            :picker-options="pickerOptions"
            value-format="yyyy-MM"
            style="width:210px"
            v-model="queryParams.month"
            type="month"
            @change="search"
            placeholder="选择月">
          </el-date-picker>
      </el-form-item>
      <el-form-item  prop="year" v-if="yearShow">
          <el-date-picker
            :picker-options="pickerOptions"
            value-format="yyyy"
            style="width:210px"
            v-model="queryParams.year"
            type="year"
            @change="search"
            placeholder="选择年">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-hasPermi="['order:export']">导出</el-button>
      </el-form-item>
    </el-form>
    <!-- 内容部分 -->
    <el-table :data="tableData" border show-summary>
          <el-table-column 
            align = "center" 
            v-for = "(item,index) in headerData" 
            :key = "index" 
            :prop = "item.prop"
            :label = "item.nameData" ></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { userOrderDaylist } from "@/api/api.js"; //运营情况统计详细数据
import { userOrderDayexport } from "@/api/api.js"; //运营情况统计详细数据
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name: "orderDataStatistics",
  data() {
    return{
      // 未到的日期不可选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); 
        }
      },
      queryParams:{
        userId:undefined,
        dateKey:undefined,
        currency:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      searchTime:[],
      monthTime:"",
      yearTime:"",
      searchTimeShow:false,
      yearShow:false,
      monthShow:false,
      agentTree: [],
      timeArr:[
        { value: 1, label: "年" },
        { value: 2, label: "月" },
        { value: 3, label: "范围" },
      ],
      headerData:[
        {
          prop:"ids",
          nameData:"序号"
        },
        {
          prop:"companyName",
          nameData:"代理商"
        },
        {
          prop:"orderNum",
          nameData:"订单数量"
        },
        {
          prop:"orderMoney",
          nameData:"订单金额"
        },
        {
          prop:"commissionMoney",
          nameData:"佣金金额"
        },
        {
          prop:"commissionNum",
          nameData:"佣金数量"
        },
        {
          prop:"newMoney",
          nameData:"补卡金额"
        },
        {
          prop:"newNum",
          nameData:"补卡数量"
        },
        {
          prop:"stopMoney",
          nameData:"停机保号金额"
        },
        {
          prop:"stopNum",
          nameData:"停机保号数量"
        },
        {
          prop:"totalMoney",
          nameData:"总金额"
        },
        {
          prop:"billDate",
          nameData:"账单日期"
        },
      ],
      currencyList:[
        // 人民币 美元 欧元 英镑 日元 泰铢
        { value: "RMB", label: "人民币 - RMB"},
        { value: "USD", label: "美元 - USD"},
        { value: "EUR", label: "欧元 - EUR"},
        { value: "GBP", label: "英镑 - GBP"},
        { value: "JPY", label: "日元 - JPY"},
        { value: "THB", label: "泰铢 - THB"},
      ],
    }
  },
  computed:{
    countTotal(){
      let totalPrice = 0;
      totalPrice = this.tableData.reduce((prev, next) => {
        return prev + Number(next.totalMoney);
      }, 0);
      return  this.formatDecimal(totalPrice,2)
    }
  },
  methods: {
    //代理商下拉列表
    handleAgentTreeList() {
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
    // 按年月日筛选
    selectSearch(){
      this.an = true;
      if(this.queryParams.dateKey == "1"){
        this.yearShow = true;
        this.monthShow = false;
        this.searchTimeShow = false;
        this.$set(this.queryParams,"month","");
        this.searchTime = [];
      }else if(this.queryParams.dateKey == "2"){
        this.monthShow = true;
        this.yearShow = false;
        this.searchTimeShow = false;
        this.$set(this.queryParams,"year","");
        this.searchTime = [];
      }else{
        this.searchTimeShow = true;
        this.yearShow = false;
        this.monthShow = false;
        this.$set(this.queryParams,"month","");
        this.$set(this.queryParams,"year","");
      }
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.searchTime = [];
      this.yearShow = false;
      this.monthShow = false;
      this.searchTimeShow = false;
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      if (this.searchTime && this.searchTime[0]) {
        params.model.startTime = this.searchTime[0];
        params.model.endTime = this.searchTime[1];
      }
      userOrderDaylist(params).then(res =>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
          });
          this.total = res.data.data.total;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1;
      this.initData();
    },
    // 导出
    handleExport(){
      let params = {
        ... this.addDateRange(this.queryParams, this.searchTime),
      };
      this.$alert("确定要统计数据导出吗？", "统计数据导出", {
        confirmButtonText: "确定"
      }).then(() => {
        userOrderDayexport(params).then(res => {
          this.$notify({
              title: "成功",
              message: "列表导出成功，请在任务中心查看",
              type: "success"
            });
        });
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },

  },
  created() {
    
  },
  mounted() {
    this.handleAgentTreeList();
    this.initData();
  },

};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
.countTotalClass{
  width: 90%;
  margin-top: 10px;
  text-align: right;
  font-size: 14px;
  color: #CCCCCC;
}
</style>


